import React, { useEffect } from "react";
import { motion, useAnimationControls } from "framer-motion";
import { twMerge } from "tailwind-merge";
import Dummy from "../src/dummy.png"

export const App = () => {
  return (
    <div className="grid h-screen w-screen place-content-center overflow-hidden bg-stone-200 relative">
      <Cards />
    </div>
  );
};

const Cards = () => {
  return (
    <div className="relative w-screen h-screen flex justify-center items-center">
      <Card
        src={Dummy}
        alt="Card 1"
        initialPosition={{ x: "-150%", y: "150%" }}
        finalPosition={{ x: "-30%", y: "-20%" }}
        initialRotate={-45}
        finalRotate={-10}
        delay={0}
        className="w-[80vw] md:w-[60vw] max-w-[600px] grayscale"
      />
      <Card
        src="https://images.unsplash.com/photo-1576174464184-fb78fe882bfd?q=80&w=2787&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
        alt="Card 2"
        initialPosition={{ x: "120%", y: "-150%" }}
        finalPosition={{ x: "30%", y: "-10%" }}
        initialRotate={45}
        finalRotate={10}
        delay={1}
        className="w-[80vw] md:w-[60vw] max-w-[600px] grayscale"
      />
      <Card
        src="https://images.unsplash.com/photo-1503751071777-d2918b21bbd9?q=80&w=2670&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
        alt="Card 3"
        initialPosition={{ x: "200%", y: "170%" }}
        finalPosition={{ x: "-20%", y: "20%" }}
        initialRotate={-30}
        finalRotate={-5}
        delay={2}
        className="w-[80vw] md:w-[60vw] max-w-[600px] grayscale"
      />
      <Card
        src="https://images.unsplash.com/photo-1602212096437-d0af1ce0553e?q=80&w=2671&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
        alt="Card 4"
        initialPosition={{ x: "-150%", y: "50%" }}
        finalPosition={{ x: "0%", y: "0%" }}
        initialRotate={30}
        finalRotate={0}
        delay={3}
        className="w-[80vw] md:w-[60vw] max-w-[600px]"
      />
    </div>
  );
};

const Card = ({
  src,
  alt,
  initialPosition,
  finalPosition,
  initialRotate,
  finalRotate,
  delay,
  className
}) => {
  const controls = useAnimationControls();

  useEffect(() => {
    const animateCard = async () => {
      await new Promise(resolve => setTimeout(resolve, delay * 500));
  
      await controls.start({
        x: finalPosition.x,
        y: finalPosition.y,
        rotate: finalRotate,
        transition: {
          duration: 1.5,
          ease: "easeInOut"
        }
      });
  
      await new Promise(resolve => setTimeout(resolve, 2000));
  
      await controls.start({
        x: initialPosition.x,
        y: initialPosition.y,
        rotate: initialRotate,
        transition: {
          duration: 1.5,
          ease: "easeInOut"
        }
      });
    };
  
    animateCard();
  }, [
    controls,
    delay,
    finalPosition.x,
    finalPosition.y,
    finalRotate,
    initialPosition.x,
    initialPosition.y,
    initialRotate
  ]);
  

  return (
    <motion.img
      animate={controls}
      initial={{
        x: initialPosition.x,
        y: initialPosition.y,
        rotate: initialRotate
      }}
      style={{
        border: "15px solid white",
        position: "absolute"
      }}
      className={twMerge(
        "bg-neutral-900 p-1 pb-4",
        className
      )}
      src={src}
      alt={alt}
    />
  );
};

export default App;